import { useState, useEffect } from "react";
import { STORAGE_KEYS } from "@/config/storageKeys";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Cookie, X } from "lucide-react";
import { Button } from "@/components/ui/button";

const CookieBanner = () => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(STORAGE_KEYS.COOKIE_CONSENT);
    if (!consent) setVisible(true);
  }, []);

  const accept = () => { localStorage.setItem(STORAGE_KEYS.COOKIE_CONSENT, "accepted"); setVisible(false); };
  const decline = () => { localStorage.setItem(STORAGE_KEYS.COOKIE_CONSENT, "declined"); setVisible(false); };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4">
      <div className="max-w-4xl mx-auto glass rounded-2xl p-5 border border-white/10 flex flex-col sm:flex-row items-start sm:items-center gap-4">
        <Cookie className="w-6 h-6 text-primary flex-shrink-0 mt-0.5" />
        <p className="text-slate-300 text-sm flex-1">
          {t('legal.cookies.text')}{" "}
          <Link to="/privacy" className="text-primary underline hover:no-underline">
            {t('legal.nav.privacy')}
          </Link>.
        </p>
        <div className="flex gap-2 flex-shrink-0">
          <Button size="sm" variant="ghost" onClick={decline} className="text-slate-400 hover:text-white gap-1">
            <X className="w-4 h-4" />{t('legal.cookies.decline')}
          </Button>
          <Button size="sm" onClick={accept} className="btn-glow bg-primary-strong hover:bg-primary-strong/90">
            {t('legal.cookies.accept')}
          </Button>
        </div>
      </div>
    </div>
  );
};
export default CookieBanner;
